import { render, staticRenderFns } from "./infobak.vue?vue&type=template&id=6a40d8a9&lang=pug"
import script from "./infobak.vue?vue&type=script&lang=js"
export * from "./infobak.vue?vue&type=script&lang=js"
import style0 from "./infobak.vue?vue&type=style&index=0&id=6a40d8a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports